import { render, staticRenderFns } from "./DispatchDialog.vue?vue&type=template&id=7880fd02&scoped=true&"
import script from "./DispatchDialog.vue?vue&type=script&lang=js&"
export * from "./DispatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880fd02",
  null
  
)

export default component.exports